<template>
      <v-card height="200px">
        <v-container fluid grid-list-md>
          <v-layout wrap>
            <v-flex xs6>
                <v-card class="white--text" >
                    <v-img src="https://www.originenergy.com.au/content/dam/origin/blog/what-is-electricity-tall.png" aspect-ratio="1.7" height="180px">
                    <v-card-title primary-title>
                        <div>
                            <div class="headline">Energy Usage</div>
                            <div>
                                <v-icon dark>flash_on</v-icon>
                                <span class='subtitle-1'>  Building load: {{reqPower}}</span>
                            </div>
                            <div>
                                <v-icon dark>wb_sunny</v-icon>
                                <span class='subtitle-1'>  Power from solar panel: {{solarPower}}</span>
                            </div>
                            <div>
                                <v-icon dark>input</v-icon>
                                <span class='subtitle-1'>  Power returns to grid: {{netPower}}</span>
                            </div>
                        </div>
                    </v-card-title>
                    </v-img>
                </v-card>
            </v-flex>
            <v-flex xs6>
                <v-card class="white--text">
                    <v-img src="https://3c1703fe8d.site.internapcdn.net/newman/csz/news/800/2017/newultrathin.png" aspect-ratio="1.7" height="180px">
                    <v-card-title primary-title>
                        <div>
                            <div class="headline">Water Usage</div>
                            <div>
                                <v-icon dark>waves</v-icon>
                                <span class='subtitle-1'>  Required water: Not Available</span>
                            </div>
                            <div>
                                <v-icon dark>opacity</v-icon>
                                <span class='subtitle-1'>  Water supply : Not Available</span>
                            </div>
                            <div>
                                <v-icon dark>input</v-icon>
                                <span class='subtitle-1'>  City water supply: Not Available</span>
                            </div>
                        </div>
                    </v-card-title>
                    </v-img>
                </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
</template>



<script>
  export default {
    data: () => ({
    }),
    methods: {
    },
    computed: {
      reqPower(){
        return this.$store.state.skyspark.reqPower;
      },
      solarPower(){
        return this.$store.state.skyspark.solarPower;
      },
      netPower(){
        return this.$store.state.skyspark.netPower;
      }
    },
    mounted() {
    },
  }

</script>>
